"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogout = void 0;
const react_1 = require("react");
const useTriaConnector_1 = require("./useTriaConnector");
const constants_1 = require("../utils/constants");
function useLogout({ authUrl }) {
    const [success, setSuccess] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const authResponse = (event) => {
            try {
                if (event.origin !== authUrl)
                    return;
                const eventData = (0, useTriaConnector_1.parseEventData)(event);
                if (eventData.type == constants_1.eventTypes.logout) {
                    console.log('Logged out!');
                    setSuccess(true);
                    window.parent.postMessage(event.data, document.referrer);
                }
            }
            catch (err) {
                setSuccess(false);
            }
        };
        window.addEventListener('message', authResponse);
        return () => {
            window.removeEventListener('message', authResponse);
        };
    }, []);
    return { success };
}
exports.useLogout = useLogout;
